<template>
  <div>
    <slot
      name="activator"
      :toggle="toggleDisclosure"
      :is-active="isActive"
      :aria-expanded="isActive"
      :aria-controls="ariaControls"
    />
    <BaseAccordionAnimation :is-open="isActive">
      <slot name="content" :id="ariaControls" />
    </BaseAccordionAnimation>
  </div>
</template>

<script setup>
import { ref, useId } from 'vue'
import BaseAccordionAnimation from '@/shared/components/BaseAccordionAnimation.vue'

const props = defineProps({
  initialActiveState: {
    type: Boolean,
    default: false,
  },
})

const ariaControls = `growthmentor-disclosure-${useId()}`
const isActive = ref(props.initialActiveState)

const toggleDisclosure = () => {
  isActive.value = !isActive.value
}
</script>
